import Vue from 'vue';
import VueLocalStorage from 'vue-localstorage';

import constConfig from '@/util/constConfig';

Vue.use(VueLocalStorage);

const { tokenName } = constConfig;

export const getToken = () => Vue.localStorage.get(tokenName);

export const setToken = token => Vue.localStorage.set(tokenName, token);

export const removeToken = () => Vue.localStorage.remove(tokenName);

export const getItem = itemKey => Vue.localStorage.get(itemKey);

export const setItem = (itemKey, token) => Vue.localStorage.set(itemKey, token);

export const removeItem = itemKey => Vue.localStorage.remove(itemKey);



// WEBPACK FOOTER //
// ./src/util/token.js